import React from 'react';
import intl from 'react-intl-universal';

function NotFound() {
  return <div>{intl.get('app_page_not_found')}</div>;
}

export default NotFound;
